import { render } from "./PluginsPage.vue?vue&type=template&id=13c58da6&scoped=true"
import script from "./PluginsPage.vue?vue&type=script&lang=js"
export * from "./PluginsPage.vue?vue&type=script&lang=js"

import "./PluginsPage.vue?vue&type=style&index=0&id=13c58da6&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c58da6"]])

export default __exports__